import React, {useContext} from 'react';
import {TextField} from "@mui/material";
import {getHelperStyle} from "../../../styles/components/FormStyle";
import {Controller} from "react-hook-form";
import {languages} from "../../../strings/LanguageDictionary";
import {AppContext} from "../../../App";

const CustomText = ({
	                    name, label, autoFocus, autoComplete, type, className = "",
	                    inputProps, error, disabled, handleKeyDown = false, handleKeyPress = false,
	                    placeholder, onBlur, control, defaultValue = "", rules, size = "medium", variant = "outlined"
                    }) => {
	const appContext = useContext(AppContext);

	return (
		<React.Fragment>
			<Controller
				name={name}
				rules={rules}
				control={control}
				defaultValue={defaultValue}
				render={({onChange, value}) => (
					<TextField
						value={value ? value : ""}
						margin='dense'
						onChange={onChange}
						className={className}
						onKeyDown={(event) => handleKeyDown ? handleKeyDown(event) : {}}
						onKeyPress={(event) => handleKeyPress ? handleKeyPress(event) : {}}
						disabled={disabled}
						onBlur={onBlur}
						id={name}
						placeholder={placeholder}
						label={label}
						autoFocus={autoFocus}
						autoComplete={autoComplete}
						type={type}
						fullWidth={true}
						size={size}
						variant={variant}
						error={error !== undefined}
						helperText={error?.type === "validate" ? languages[appContext.state.lang].OCEAN__GLOBAL_NOT_VALID_FILES : error?.message ? languages[appContext.state.lang].OCEAN__GLOBAL_REQUIRED_FILES_ : ""}
						slotProps={{
							htmlInput: inputProps,
							formHelperText: {
								style: getHelperStyle().helper
							}
						}}
					/>
				)}/>
		</React.Fragment>
	);
}

export default React.memo(CustomText)
